import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdy3rv4yv2: FaireProductEntity = {
  token: "p_gdy3rv4yv2",
  type: "product",
  name: "Spa Bath Body Gift Set| Natural Skincare Gift Sets",
  brandToken: "b_85m6bbbiw6",
  brandName: "Natural Amor LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/057998255f46843c9d7356050a0f215f386b6489878e8f9f66c2add116fa5183.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c83ff9035da1e6730046ac9ba507da0430be84fc2725673dd657fc270613b690.jpeg",
    "https://cdn.faire.com/fastly/db65bffa3b5f94a2c8bc636904cc58a7c8a6a7567ef3708d42054f3e55cd3ceb.jpeg",
    "https://cdn.faire.com/fastly/f12f3254a02c501617a68956a890d5c84b05858434b9ed0758e4ba8e8a5e314d.jpeg",
    "https://cdn.faire.com/fastly/2fd4f3a5b73a51a408fcc8a7dbf8a1977046b0dba8ae16e3ace4a89db2221fa2.jpeg",
    "https://cdn.faire.com/fastly/967dbeae411f65d618cc83970e929e39927eea950421993c5a249aaf490e63c5.jpeg",
    "https://cdn.faire.com/fastly/74be658d2102668cac2003d1ac773af8665e6e61247bc9e3945b89ca41c48430.jpeg",
    "https://cdn.faire.com/fastly/2b0208056146d57c7d4a83f8727be565823ac01c9fd945fdd6f1703dd3bce31b.jpeg",
    "https://cdn.faire.com/fastly/167b2d3d3275420f850f40a7d5d6ee8223773ec92b62c8dc50512ccf98f8fb41.jpeg",
    "https://cdn.faire.com/fastly/250591df8ef8b547334d48f96274f12a9cb56c255bdc127c5cb899c016b98c3e.jpeg",
    "https://cdn.faire.com/fastly/f42c7ae814359e99e78fb4817dfe64c1cb46d325169c988fb4c341e58d89aeef.jpeg",
    "https://cdn.faire.com/fastly/dddfa405427360c0a423748edec56396c8de064dcaed32c6239c0e54236b79a4.jpeg",
    "https://cdn.faire.com/fastly/459f414abed49bafdf8b2a1c7548760b8352fe12ae955671d4f1952b75983633.jpeg",
    "https://cdn.faire.com/fastly/88073fe63cd750eaae733fb25b2238a131d7965b8e31fa7e9ec837b5c69a2d49.jpeg",
    "https://cdn.faire.com/fastly/a3b36c9db154b022fd03165c93bdabd63054428bc50fb3d23f27f53e4ccb467d.webp",
  ],
  priceDollars: 27.5,
  description:
    "Our Handmade Bath Body Gift Set collection features luxurious items like handmade soap, bath salts, and bath bombs, all crafted in Sunny California with natural ingredients. This thoughtfully curated set includes everything you need to unwind and indulge in a soothing, spa-like experience right in the comfort of your home. Each product is made with care to promote relaxation and rejuvenation, offering a moment of self-care that nourishes both body and mind.\n\nGreat gift idea for customers, employees, or friends.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:28.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
